<div class="body-container-wrapper">
    <section class="inner-page-banner light-banner support-banner banner-image">
        <div class="container">
            <div class="banner-caption">
                <h1>You-As-Priority Mode, Always</h1>
                <h6>We are always available to assist you with your wealth journey. Find your nearest BajajCapital
                    branch.</h6>
            </div>
        </div>
        <div class="section-menu scroll_active" data-href="#section-menu" id="section-menu">
            <ul>
                <li class="scroll_active" data-href="#query"><a href="#query">Query
                        Form</a></li>
                <li class="scroll_active" data-href="#branch"><a href="#branch">Branch Locator</a></li>
                <li class="scroll_active" data-href="#offices"><a href="#offices">Offices</a></li>
                <li class="scroll_active" data-href="#investor-grievance-escalation-matrix-DP"><a
                        href="#investor-grievance-escalation-matrix-DP">Investor Grievance Escalation Matrix-DEMAT
                        SERVICES</a></li>
            </ul>
            <div class="mobile-scroll-menu d-sm-none">
                <span>Jump to Section</span>
                <div class="custom-dropdown">
                    <span class="selected-item form-control">Query Form</span>
                    <ul>
                        <li class="active"><a href="#query">Query Form</a></li>
                        <li><a href="#branch">Branch Locator</a></li>
                        <li><a href="#offices">Offices</a></li>
                        <li><a href="#investor-grievance-escalation-matrix-DP">Investor Grievance Escalation
                                Matrix-DEMAT SERVICES</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section class="qyery-form-section bgwhite anchor-ptop" id="query">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-11 col-lg-9 col-xl-8">
                    <h2 class="card-title section-title">Fill for requesting a call back<span class="wow"></span></h2>
                    <div class="card banner-form">
                        <div class="card-body">
                            <form autocomplete="off" id="form1">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="">Full Name </label>
                                        <input type="text" class="form-control"
                                            placeholder="Please enter your full name" maxlength="40" id="userName"
                                            autocomplete="off" name="userName" required="true">

                                        <!-- <div *ngIf="namevalidateMessage == 'required'" class="red">
                                            Full Name is mandatory
                                        </div>
                                        <div *ngIf="namevalidateMessage == 'invalidate'" class="red">
                                            Name is incorrect format
                                        </div>
                                        <div *ngIf="namevalidateMessage == 'lengthError'" class="red">
                                            Minimum length must be 4 character.
                                        </div> -->
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="">Email Address <sup>(optional)</sup></label>
                                        <input type="text" (keydown.space)="$event.preventDefault();"
                                            class="form-control" placeholder="Your email id" id="userEmail"
                                            autocomplete="off" maxlength="50" name="email" required="true">
                                        <!-- <div *ngIf="emailMessage == 'pattern'" class="red">
                                            Please enter the email address in the format of abc@xyz.com
                                        </div>
                                        <div *ngIf="emailMessage == 'required'" class="red">
                                            Email Id is mandatory
                                        </div> -->
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="">Mobile Number</label>
                                        <input type="text" class="form-control" placeholder="Enter your mobile no."
                                            id="userMob" name="mobilno" autocomplete="off" required="true"
                                            minlength="10" maxlength="10">
                                        <!-- <div *ngIf="mobileMesaage == 'pattern'" (ngModelChange)="ValidateMobile()"
                                            class="red animated bounceInUp delay-02">
                                            Enter a valid 10 digit mobile number
                                        </div>
                                        <div *ngIf="mobileMesaage == 'required'" class="red">
                                            10 digit mobile number is mandatory
                                        </div>
                                        <div *ngIf="mobileMesaage == 'invalid'" class="red">
                                            Mobile number is not valid
                                        </div>
                                        <div *ngIf="mobileMesaage == 'alredyexist'" class="red">
                                            The mobile/ email is already registered.Kindly login to continue Or Use
                                            forgot password link to reset
                                            login
                                        </div> -->
                                    </div>
                                    <!-- city list form field starts here -->
                                    <div class="form-group col-md-6">
                                        <label for="">City/District</label>
                                        <select class="selected-item  form-control" name="city" #city>
                                            <option selected disabled value="">Select City/District</option>
                                            <!-- <option *ngFor="let city of cityList;" [value]="city.name+'-'+city.Id">
                                                {{city.name}}
                                            </option> -->
                                        </select>
                                        <!-- <div *ngIf="cityMesaage == 'required'" class="red">
                                            City selection is mandatory
                                        </div> -->
                                    </div>
                                    <!-- city list form field ends here -->
                                    <!-- service list form field starts here -->
                                    <div class="form-group col-md-6">
                                        <label for="">Service </label>
                                        <select class="selected-item  form-control" name="service" #service>
                                            <option selected disabled value="">Select Service</option>
                                            <!-- <ng-container *ngFor="let service of serviceList">
                                                <option [value]="service.name+'-'+service.tid"
                                                    *ngIf="service.status=='True'">
                                                    {{service.name}}
                                                </option>
                                            </ng-container> -->
                                        </select>
                                        <!-- <div *ngIf="serviceMessage == 'required'" class="red">
                                            Service selection is mandatory
                                        </div> -->
                                    </div>
                                    <!-- service list form field ends here -->
                                    <!-- preffered slot list form field starts here -->
                                    <div class="form-group col-md-6">
                                        <label for="">Preferred Slot</label>
                                        <select class="selected-item  form-control" name="slot" #slot>
                                            <option selected disabled value="">Select Slot</option>
                                            <!-- <option *ngFor="let slot of slotList" [value]="slot.slot_name+'-'+slot.Id">
                                                {{slot.slot_name}}
                                            </option> -->
                                        </select>
                                        <!-- <div *ngIf="slotMessage == 'required'" class="red">
                                            Slot selection is mandatory
                                        </div> -->
                                    </div>
                                    <!-- preffered slot list form field ends here -->


                                    <div class="form-group col-12">
                                        <label for="">Your Query</label>
                                        <textarea class="form-control" placeholder="Type Query in the box below"
                                            maxlength="250" id="userQuery" autocomplete="off" name="userQuery"
                                            required="true" appNoScriptTag></textarea>
                                        <!-- <div *ngIf="queryMessage == 'required'" class="red">
                                            This is required
                                        </div>
                                        <div *ngIf="queryMessage == 'lengthError'" class="red">
                                            Minimum length must be 10 character.
                                        </div> -->
                                    </div>
                                    <div class="text-center col-12">
                                        <button type="submit" class="btn btn-primary"
                                            id="query-submit">Continue</button>
                                    </div>
                                    <div class="text-center col-12">
                                        <small>By continuing, you provide consent and agree to our <a
                                                [routerLink]="['/term-conditions']" [queryParams]="{doc:'tnc'}">Terms &
                                                Conditions.</a></small>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="card-body otp-card">
                            <p class="mb-3"><a href="javascript:void(0)" id="btn-back"><i
                                        class="fa fa-chevron-left"></i> Change Number</a></p>
                            <div class="alert alert-success"><i class="fa fa-check"></i> <span class="ms-3">OTP
                                    successfully sent on
                                    number 9843787347</span></div>
                            <div class="form-group" style="max-width: 400px;">
                                <input type="text" class="form-control" placeholder="Enter OTP" id="userotp" name="otp"
                                    autocomplete="off" required="true" minlength="6" maxlength="6">
                                <!-- <div *ngIf="otpMessage == 'resent'" class="green">
                                    <i class="fa fa-check"> </i> OTP resent.
                                </div>
                                <div *ngIf="otpMessage == 'required'" class="red">
                                    Please enter OTP to continue.
                                </div>
                                <div *ngIf="otpMessage == 'invalid'" class="red">
                                    Incorrect OTP entered. Please try again.
                                </div>
                                <div *ngIf="otpMessage == 'lengtherr'" class="red">
                                    Please enter complete OTP.
                                </div>
                                <div *ngIf="otpMessage == 'excesserr'" class="red">
                                    You have exceeded the retry limit. Please re-enter details.
                                </div> -->
                            </div>
                            <div class="form-group text-center">
                                <button id="otp-submit" class="btn btn-primary">Submit</button>
                            </div>

                            <div class="form-group text-center">
                                <span class="timer">Didn't recieve OTP? Resend in <strong
                                        style="font-size:15px;">30</strong>seconds</span>
                                <a class="resendotp" href="javascript:void(0)">Resend
                                    OTP</a>
                            </div>
                        </div>
                        <div class="card-body success-card">
                            <div class="success-tick">
                                <h2>Thank you!</h2>
                            </div>
                            <h6>Your query has been successfully submitted. We will get in touch with you shortly.</h6>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8 col-xl-7 text-center">
                    <p>Alternative, just drop our customer support team a mail at <a
                            href="mailto:contactus@bajajcapital.com">contactus&#64;bajajcapital.com</a>
                        any time of the day, or call <a href="tel:8978676565">8756756446</a>
                        <span> / <a href="tel: 9867565566">
                                9876675657</a></span> Mon - Sat(10AM - 6PM).
                    </p>
                </div>
                <div class="col-md-12 col-lg-10 col-xl-8">
                    <div class="social-media mt-5">
                        <span>Our social media presence:</span>
                        <!-- <ul>
                            <li>
                                <a href="https://www.facebook.com/bajajcapital" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            </li>
                            <li>
                                <a href="https://twitter.com/mybajajcapital" target="_blank"><i class="fab fa-twitter"></i></a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/bajaj-capital-ltd" target="_blank"><i class="fab fa-linkedin-in"></i></a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/bajaj_capital/" target="_blank"><i class="fab fa-instagram"></i></a>
                            </li> 
                        </ul> -->
                        <ul class="social-links">
                            <li><a href="https://www.facebook.com/bajajcapital" target="_blank"><img alt="facebook"
                                        src="../../assets/images/help-center/facebook-icon.png" /> </a></li>
                            <li><a href="https://twitter.com/mybajajcapital" target="_blank"><img alt="x"
                                        src="assets/images/help-center/twitter-icon.png" /> </a></li>
                            <li><a href="https://www.linkedin.com/company/bajaj-capital-ltd" target="_blank"><img
                                        alt="linkedin" src="assets/images/help-center/linkden-icon.png" /> </a></li>
                            <li><a href="https://instagram.com/bajaj_capital" target="_blank"><img alt="instagram"
                                        src="assets/images/help-center/instagram.png" /></a></li>
                            <li><a href="https://www.youtube.com/channel/UCHd387ggvz3JC7I9wVtPhtw" target="_blank"><img
                                        alt="youtube" src="assets/images/help-center/youtube-icon.png" /> </a></li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="branch-locator-section anchor-ptop" id="branch">
        <div class="container">
            <app-branch-locator></app-branch-locator>
        </div>
    </section>
    <section class="bgwhite offices-section" id="offices">
        <div class="container">
            <app-office-list></app-office-list>
        </div>
    </section>
    <section class="sub-footer">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-md-12 col-lg-10 col-xl-8">
                    <h2 class="card-title section-title">Regulatory Information<span class="wow"></span></h2>
                    <p>All visitors who visit the site <a [routerLink]="['/']">https://www.bajajcapital.com</a> ('Site')
                        and provide information to BajajCapital Limited ('BCL') online through this Site are covered
                        under our Privacy Policy.<br><a [routerLink]="['/term-conditions']" [queryParams]="{doc:'tnc'}"
                            class="btn read-more">Read policy
                            details <i class="fas fa-chevron-right"></i></a></p>
                </div>
            </div>
        </div>
    </section>
    <section class="text-center" id="investor-grievance-escalation-matrix-DP">
        <a href="/assets/Annexure A.pdf" target="_blank" class="a">Investor Grievance Escalation Matrix-DEMAT
            SERVICES</a>
    </section>
</div>